var exports = {
  "kL": "GameActivityDisplay.module__container___RVdWNj",
  "Eb": "GameActivityDisplay.module__activity___RVdWNj",
  "Kk": "GameActivityDisplay.module__icon___RVdWNj",
  "zH": "GameActivityDisplay.module__details___RVdWNj",
  "Pf": "GameActivityDisplay.module__label___RVdWNj",
  "p0": "GameActivityDisplay.module__duration___RVdWNj",
  "UU": "GameActivityDisplay.module__name___RVdWNj",
};

module.exports = exports;
